// ---- Video overlay repositioning: runs on EVERY product page ----
// Moved outside the #MrBundle guard below, since products without a
// Size/Pack option (e.g. Ritual Sets) still have a testimonial video
// overlay that needs to be attached to the first gallery image.
document.addEventListener('DOMContentLoaded', function(){
  attachVideoOverlayToFirstImage();
});

function attachVideoOverlayToFirstImage(){
  var overlay = document.querySelector('.mr-video-overlay');
  if(!overlay) return;

  var activeGallery = document.querySelector('[data-mr-size-gallery]:not([style*="display: none"])')
    || document.querySelector('[data-mr-size-gallery]')
    || document.querySelector('[id^="MediaGallery-"]');
  if(!activeGallery) return;

  var firstItem = activeGallery.querySelector('.m-product-media--item[data-index="0"]')
    || activeGallery.querySelector('.m-product-media--item');
  if(!firstItem) return;

  if(overlay.parentElement !== firstItem){
    firstItem.style.position = 'relative';
    firstItem.appendChild(overlay);

  }
}

// ---- Bundle / Pack selector: only runs on products that have #MrBundle ----
document.addEventListener('DOMContentLoaded', function(){
  var root = document.getElementById('MrBundle');
  if(!root) return;

  var sizePos = parseInt(root.getAttribute('data-size-position'), 10);
  var packPos = parseInt(root.getAttribute('data-pack-position'), 10);
  var variants = JSON.parse(document.getElementById('MrBundleVariants').textContent);

  var sizeBtns = Array.prototype.slice.call(document.querySelectorAll('#MrBundleSizes [data-size]'));
  var packCards = Array.prototype.slice.call(document.querySelectorAll('#MrBundleCards [data-pack]'));
  var cta = document.getElementById('MrBundleCta');
  var lowStock = document.getElementById('MrBundleLowStock');

  function optKey(pos){ return 'option' + pos; }

  // Start on the first purchasable combination. If the whole product is sold out,
  // retain the first combination so the customer sees a clear Sold Out state.
  var firstAvailable = variants.filter(function(v){ return v.available !== false; })[0] || variants[0] || null;
  var activeSize = sizePos > 0 && firstAvailable
    ? firstAvailable[optKey(sizePos)]
    : (sizeBtns.length ? sizeBtns[0].getAttribute('data-size') : null);
  var activePack = firstAvailable
    ? firstAvailable[optKey(packPos)]
    : (packCards.length ? packCards[0].getAttribute('data-pack') : null);

  sizeBtns.forEach(function(btn){
    btn.classList.toggle('is-active', btn.getAttribute('data-size') === activeSize);
  });
  packCards.forEach(function(card){
    card.classList.toggle('is-selected', card.getAttribute('data-pack') === activePack);
  });

  function findVariant(sizeVal, packVal){
    return variants.filter(function(v){
      var sizeMatches = sizePos > 0 ? v[optKey(sizePos)] === sizeVal : true;
      return sizeMatches && v[optKey(packPos)] === packVal;
    })[0] || null;
  }

  function money(cents){
    if(typeof cents !== 'number') return '';
    var v = Math.round(cents/100).toLocaleString('en-PK');
    return 'Rs. ' + v;
  }

  function broadcast(){
    var v = findVariant(activeSize, activePack);
    document.dispatchEvent(new CustomEvent('mr:bundle:change', {
      detail: { size: activeSize, pack: activePack, variant: v }
    }));
  }

  function setStockBadge(container, soldOut){
    var badge = container.querySelector('[data-mr-stock-badge]');
    if(!badge){
      badge = document.createElement('span');
      badge.className = 'mr-bundle__stock-badge';
      badge.setAttribute('data-mr-stock-badge', '');
      badge.textContent = '× Sold out';
      container.appendChild(badge);
    }
    badge.hidden = !soldOut;
  }

  function sizeIsAvailable(sizeVal){
    return variants.some(function(v){
      return (sizePos <= 0 || v[optKey(sizePos)] === sizeVal) && v.available !== false;
    });
  }

  function renderLowStock(){
    if(!lowStock) return;
    var units = Number(lowStock.getAttribute('data-units-left') || 0);
    var trackedSize = lowStock.getAttribute('data-stock-size');
    lowStock.hidden = !(activeSize === trackedSize && units > 0 && units <= 8);
  }

  function render(){
    renderLowStock();
    sizeBtns.forEach(function(btn){
      var soldOut = !sizeIsAvailable(btn.getAttribute('data-size'));
      btn.classList.toggle('is-sold-out', soldOut);
      btn.setAttribute('aria-label', btn.getAttribute('data-size') + (soldOut ? ' — Sold out' : ''));
      setStockBadge(btn, soldOut);
    });

    packCards.forEach(function(card){
      var packVal = card.getAttribute('data-pack');
      var v = findVariant(activeSize, packVal);
      var soldOut = !v || v.available === false;
      var priceEl = card.querySelector('[data-price]');
      var compareEl = card.querySelector('[data-compare]');
      var saveEl = card.querySelector('[data-save]');
      var unitEl = card.querySelector('[data-unit-price]');

      card.classList.toggle('is-disabled', soldOut);
      card.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      setStockBadge(card, soldOut);

      if(!v){
        priceEl.textContent = 'Unavailable';
        compareEl.textContent = '';
        saveEl.textContent = '';
        if(unitEl) unitEl.textContent = '';
        return;
      }

      priceEl.textContent = money(v.price);
      if(soldOut){
        compareEl.textContent = '';
        saveEl.textContent = '';
        if(unitEl) unitEl.textContent = '';
        return;
      }

      var packCountMatch = String(packVal).match(/\d+/);
      var packCount = packCountMatch ? parseInt(packCountMatch[0], 10) : 1;
      if(unitEl){
        unitEl.textContent = packCount > 1 ? money(Math.round(v.price / packCount)) + ' each' : '';
      }
      if(v.compare_at_price && v.compare_at_price > v.price){
        compareEl.textContent = money(v.compare_at_price);
        var savedAmount = v.compare_at_price - v.price;
        saveEl.textContent = 'Save ' + money(savedAmount).replace('Rs. ', 'Rs.');
      } else {
        compareEl.textContent = '';
        saveEl.textContent = '';
      }
    });

    var selected = findVariant(activeSize, activePack);
    var soldOut = !selected || selected.available === false;
    var pending = cta.hasAttribute('data-mr-cart-pending');
    cta.disabled = soldOut || pending;
    if(!pending) cta.textContent = soldOut ? 'Sold Out' : 'Add to Cart ▸';

    if(selected){
      var form = document.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('[name="id"]') : null;
      if(idInput){
        idInput.value = selected.id;
      }
      updatePriceBlock(selected.id);
    }

    broadcast();
  }

  var priceEl = document.querySelector('[id^="Price-"]');
  var priceSectionId = priceEl ? priceEl.id.replace('Price-', '') : null;
  var priceFetchTimer = null;

  function updatePriceBlock(variantId){
    if(!priceEl || !priceSectionId) return;
    clearTimeout(priceFetchTimer);
    priceFetchTimer = setTimeout(function(){
      var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + priceSectionId;
      fetch(url)
        .then(function(res){ return res.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshPriceEl = doc.getElementById('Price-' + priceSectionId);
          if(freshPriceEl){
            priceEl.innerHTML = freshPriceEl.innerHTML;
          }
        })
        .catch(function(){ /* fail quietly, don't break the page */ });
    }, 120);
  }

  function filterGalleryBySize(sizeVal){
    var galleries = document.querySelectorAll('[data-mr-size-gallery]');
    if(!galleries.length) return;
    galleries.forEach(function(g){
      var match = g.getAttribute('data-mr-size-gallery') === sizeVal;
      g.style.display = match ? '' : 'none';
    });
    window.dispatchEvent(new Event('resize'));
    attachVideoOverlayToFirstImage();
  }

  attachVideoOverlayToFirstImage();

  sizeBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      activeSize = btn.getAttribute('data-size');
      sizeBtns.forEach(function(b){ b.classList.toggle('is-active', b === btn); });
      filterGalleryBySize(activeSize);
      render();
    });
  });

  filterGalleryBySize(activeSize);

  packCards.forEach(function(card){
    card.addEventListener('click', function(){
      if(card.classList.contains('is-disabled')) return;
      activePack = card.getAttribute('data-pack');
      packCards.forEach(function(c){ c.classList.toggle('is-selected', c === card); });
      render();
    });
  });

  var qtyValueEl = document.getElementById('MrBundleQtyValue');
  var qtyDecreaseBtn = document.querySelector('[data-qty-decrease]');
  var qtyIncreaseBtn = document.querySelector('[data-qty-increase]');
  var realQtyInput = document.querySelector('input[name="quantity"]');

  function getQty(){
    if(realQtyInput && realQtyInput.value){ return parseInt(realQtyInput.value, 10) || 1; }
    return parseInt(qtyValueEl.textContent, 10) || 1;
  }

  function setQty(val){
    if(val < 1) val = 1;
    qtyValueEl.textContent = val;
    if(realQtyInput){
      realQtyInput.value = val;
      realQtyInput.dispatchEvent(new Event('change', {bubbles:true}));
      realQtyInput.dispatchEvent(new Event('input', {bubbles:true}));
    }
  }

  setQty(getQty());

  if(qtyDecreaseBtn){
    qtyDecreaseBtn.addEventListener('click', function(){ setQty(getQty() - 1); });
  }
  if(qtyIncreaseBtn){
    qtyIncreaseBtn.addEventListener('click', function(){ setQty(getQty() + 1); });
  }

  // ---- Add to Cart: use Shopify's bundled sections in the same response. ----
  cta.addEventListener('click', function(){
    var v = findVariant(activeSize, activePack);
    if(!v || v.available === false || cta.disabled) return;
    cta.disabled = true;
    cta.setAttribute('data-mr-cart-pending', 'true');
    var originalText = cta.textContent;
    cta.textContent = 'Adding…';
    window.MarayaCart.add([{id:v.id, quantity:getQty()}], true)
      .catch(function(error){
        if(error.review){ window.location.href = window.MarayaCart.root + 'cart'; return; }
        var message = document.getElementById('MrBundleCartError');
        if(!message){ message=document.createElement('p'); message.id='MrBundleCartError'; message.setAttribute('role','alert'); cta.insertAdjacentElement('afterend',message); }
        message.textContent=error.message || 'Could not add this item. Please try again.';
      })
      .finally(function(){
        cta.removeAttribute('data-mr-cart-pending');
        render();
      });
  });

  window.MrBundle = {
    getSizes: function(){
      return sizeBtns.map(function(b){ return b.getAttribute('data-size'); });
    },
    getState: function(){
      return { size: activeSize, pack: activePack, variant: findVariant(activeSize, activePack) };
    },
    setSize: function(sizeVal){
      var btn = sizeBtns.filter(function(b){ return b.getAttribute('data-size') === sizeVal; })[0];
      if(btn) btn.click();
    }
  };

  render();
});
